module.exports = "/static/images/LJEA-logo--text.png";